import { FC } from "react";
import { Typography } from "@mui/material";
import useEhrSync from "Hooks/useEhrSync";

type EhrLastSyncProps = {
  /** The hook result for this section, so the label and its button always agree. */
  sync: ReturnType<typeof useEhrSync>;
};

/**
 * "Last synced" text shown beside an EHR sync button.
 *
 * <p>Takes the hook result rather than a domain: useEhrSync is a hook and
 * cannot be called from inside a render helper -- the same reason
 * PatientViewCard's sectionHead is shaped this way.</p>
 *
 * <p>Rendered only when the button is, so a section that cannot sync shows
 * neither a control nor a timestamp. The value is already formatted by the hook
 * and reads "Never synced" when the section has no stamp, which is the honest
 * answer rather than a blank space.</p>
 */
const EhrLastSync: FC<EhrLastSyncProps> = ({ sync }) => {
  if (!sync.canSync) return null;
  return (
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ mr: 1, whiteSpace: "nowrap" }}
    >
      Last synced: {sync.lastSync}
    </Typography>
  );
};

export default EhrLastSync;
